/* eslint-disable indent */
// @ts-nocheck
import { customMapUrl, wrapViewList } from './map'
import { map1Text, map2Text, map3Text, customList } from './data'
import md5 from 'js-md5'

const getData = (data) => {
  const paramsStr = Object.keys(data)
    .sort()
    .reduce((acc, cur) => {
      // @ts-ignore
      if (data[cur] instanceof File) {
        return acc
      }
      // @ts-ignore
      let value = data[cur]
      // @ts-ignore
      if (typeof data[cur] === 'object') {
        // @ts-ignore
        // value = JSON.stringify(data[cur]).slice(0, 50)
        value = ''
        cur = ''
      } else {
        // @ts-ignore
        const sValue = String(data[cur])
        value = sValue.length > 50 ? sValue.slice(0, 50) : value
      }

      acc += cur + value
      return acc
    }, '')
  return paramsStr
}
const sign_key = 'kjdslfkjnvushekjn430dfk12asd'
export function getSign(data, time) {
  return md5(sign_key + getData(data) + 'time' + time + sign_key)
}

const browserRedirect = () => {
  var sUserAgent = navigator.userAgent.toLowerCase()
  var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
  var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
  var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
  var bIsAndroid = sUserAgent.match(/android/i) == 'android'
  var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
  var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'

  if (
    !(
      bIsIpad ||
      bIsIphoneOs ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsAndroid ||
      bIsCE ||
      bIsWM
    )
  ) {
    //            pc
    return 0
  } else {
    //            wap
    return 1
  }
}
const getUserId = () => {
  const url = location.href
  if (url.indexOf('?') >= 0) {
    var params = url.substring(url.indexOf('?') + 1, url.length)
    if (params !== null && params !== undefined && params !== '') {
      const paramArr = params.split('&')
      for (const index in paramArr) {
        const key = paramArr[index].split('=')[0]
        const val = paramArr[index].split('=')[1]
        if (key == 'user') {
          return val
        }
      }
    }
  }
}
const getLatlngPar = () => {
  const url = location.href
  const latlng = []
  if (url.indexOf('?') >= 0) {
    var params = url.substring(url.indexOf('?') + 1, url.length)
    if (params !== null && params !== undefined && params !== '') {
      const paramArr = params.split('&')
      for (const index in paramArr) {
        const key = paramArr[index].split('=')[0]
        const val = paramArr[index].split('=')[1]
        switch (key) {
          case 'lat':
            latlng[0] = val
            break
          case 'lng':
            latlng[1] = val
            break
          default:
            break
        }
      }
    }
  }
  return latlng
}
export {
  browserRedirect,
  map1Text,
  map2Text,
  map3Text,
  customList,
  customMapUrl,
  wrapViewList,
  getUserId,
  getLatlngPar
}
